import {load} from '@shopify/theme-sections';
import '../sections/page-downloads';

document.addEventListener('DOMContentLoaded', () => {
  load('*');
});
